// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"b5d02791e01b05ba006b","883":"ac8233058cf474fb62f6"}[chunkId] + ".js";
};